import styled from '@emotion/styled'

import { Checkbox } from '../../generic-components'
import { translate } from '../../localization'
import { useDispatch, useSelector } from 'react-redux'
import { selectSelectedDaysEvents, selectSelectedEvents } from '../State/EmployeeCalendarSelectors'
import { isEmpty } from 'lodash-es'
import { setSelectedEvents } from '../State/EmployeeCalendarReducer'

const Container = styled.div`
    margin-bottom: 8px;
`

const ToggleAllEventsCheckbox = (): JSX.Element | null => {
    const dispatch = useDispatch()

    const allEvents = useSelector(selectSelectedDaysEvents)
    const selectedEvents = useSelector(selectSelectedEvents)

    if (isEmpty(allEvents)) {
        return null
    }

    const allEventsSelected = selectedEvents.length === allEvents.length

    const toggleAlLEvents = () => {
        const newSelection = !allEventsSelected ? allEvents : []

        dispatch(setSelectedEvents(newSelection))
    }

    return (
        <Container>
            <Checkbox
                id="select-all"
                value={allEventsSelected}
                variant="large"
                label={translate('valitse-kaikki')}
                onClick={toggleAlLEvents}
                noPadding
            />
        </Container>
    )
}

export default ToggleAllEventsCheckbox
